/* ----- COMPONENT TEST DATA ---- 
   for StackedTextImageForm
*/
import { newsletterForm as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  header: 'Let’s stay in touch.',
  eyebrow: "Share a few details, and we'll be in touch",
  header2: 'Thanks for your message.',
  eyebrow2: "We'll siblee in touch as soon as possible",
};

export default fakeProps(schema, TestData);
